// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { memo } from "react";
import { useDispatch } from "react-redux";

import { mdiCalculator } from "@mdi/js";
import { useChartsContext } from "contexts";
import { updateChartByPath } from "store/features";

import { useChartEntities } from "hooks/charts";

import ToolbarButton from "../../base/ToolbarButton";

const ProbitDataSourceToggle = () => {
  const dispatch = useDispatch();
  const { id } = useChartsContext();
  const { useLineOfBestFit, useProbitLineOfBestFitData } = useChartEntities(id);
  const isActive = useProbitLineOfBestFitData?.active;
  const showButton = useProbitLineOfBestFitData?.show;
  const isUseLineOfBestFitActive = useLineOfBestFit?.active;
  const toggle = (active: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: `features.useProbitLineOfBestFitData.active`,
        value: active
      })
    );
  };
  if (!showButton) return null;

  return (
    <ToolbarButton
      icon={<Icon path={mdiCalculator} size={1.3} />}
      active={isActive}
      data-testid="probit-data-source-toggle"
      overflowLabel="Use line of best fit for stats"
      tooltipText="Use line of best fit for stats"
      onToggle={toggle}
      disabled={!isUseLineOfBestFitActive}
    />
  );
};

export default memo(ProbitDataSourceToggle);
